import {
  ExitEditorDialog,
  type ExitEditorDialogProps,
} from '@carboncopyco/editor-ui';
import { memo } from 'react';
import { useEditorTool } from '../hooks/useEditorTool';

export type ExitEditorModalProps = Pick<ExitEditorDialogProps, 'onConfirm'>;

export const ExitEditorModal = memo(({ onConfirm }: ExitEditorModalProps) => {
  const { isOpen, close } = useEditorTool('exit');
  return (
    <ExitEditorDialog
      isOpen={isOpen}
      onClose={close}
      onConfirm={onConfirm}
    />
  );
});

ExitEditorModal.displayName = 'ExitEditorModal';
